var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
import { AbstractSpaceActionService } from '@/services/space-action-service';
import { I18nService } from '@/services/i18n-service';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { UserInfoService } from '@/domains/user/services/user-info-service.interface';
let SharePublicSpaceActionContribution = class SharePublicSpaceActionContribution extends AbstractSpaceActionService {
    constructor(_i18nService, _userInfoService) {
        super();
        this._i18nService = _i18nService;
        this._userInfoService = _userInfoService;
    }
    _isShareEnabled(space) {
        return space.isPublic && space.isManager;
    }
    registerSpaceActions(spaceActionRegistry) {
        spaceActionRegistry.registerSpaceAction({
            order: 98,
            commandId: 'share-public-space',
            label: this._i18nService.t('global.btn.share'),
            iconClass: 'SolidShare',
            isEnabled: (space) => {
                return this._isShareEnabled(space);
            },
            isVisible: (space) => {
                return space.isPublic;
            },
        });
    }
};
SharePublicSpaceActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __param(1, inject(UserInfoService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object, typeof (_b = typeof UserInfoService !== "undefined" && UserInfoService) === "function" ? _b : Object])
], SharePublicSpaceActionContribution);
export { SharePublicSpaceActionContribution };
